import React from 'react'

import Layout from '../components/layout'
import HomeTwo from '../components/home/HomeTwo'
import ServiceCapabilities from '../components/services/ServiceCapabilities'
import ServiceAIValueLoop from '../components/services/ServiceAIValueLoop'
import ServiceOneTeam from '../components/services/ServiceOneTeam'
import ServiceOtherSolutions from '../components/services/ServiceOtherSolutions'
import ServicePageHero from '../components/services/ServicePageHero'
import { DATA_AI_CAPABILITIES_EN } from '../constants/serviceCapabilitiesDataAi'
import { SERVICE_ONE_TEAM_APPLICATION_EN } from '../constants/serviceOneTeamContent'
import { createServiceOtherSolutionsEn } from '../constants/serviceOtherSolutionsContent'
import { SERVICE_HERO_ASSETS, SERVICE_PAGE_PILLAR_ICONS } from '../constants/serviceHeroAssets'

const DataAiPageEn = () => (
  <Layout lang="en" title="Data & AI" meta={{ description: '' }} rootProps={{ className: 'page services service-application-modernization' }}>
    <div className="service-detail-page">
      <ServicePageHero
        sectionId="service-hero"
        label="Services"
        title={'Data & AI.'}
        description={
          'We transform complex data into intelligent, actionable solutions, with scalable infrastructure and AI-powered capabilities.'
        }
        heroImage={SERVICE_HERO_ASSETS.data.src}
        imageAlt="Data and AI illustration"
        imageWidth={SERVICE_HERO_ASSETS.data.width}
        imageHeight={SERVICE_HERO_ASSETS.data.height}
        pillarIcon={SERVICE_PAGE_PILLAR_ICONS.data.src}
        pillarIconWidth={SERVICE_PAGE_PILLAR_ICONS.data.width}
      />
      <ServiceCapabilities
        idBase="service-capabilities-data-ai"
        sectionTitle="Capabilities that power Data & AI."
        tabs={DATA_AI_CAPABILITIES_EN}
        contactCtaIsEn
      />
      <ServiceAIValueLoop lang="en" />
      <HomeTwo lang="en" />
      <ServiceOneTeam
        idBase="service-one-team-data-ai"
        {...SERVICE_ONE_TEAM_APPLICATION_EN}
      />
      <ServiceOtherSolutions
        idBase="service-other-solutions-data-ai"
        {...createServiceOtherSolutionsEn('data-ai')}
      />
    </div>
  </Layout>
)

export default DataAiPageEn
